import React, { useState } from 'react';
import { ActivityRendererProps } from './types';

const ReflectionActivity: React.FC<ActivityRendererProps> = ({ activity, onComplete }) => {
  const [reflection, setReflection] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    setSubmitted(true);
    onComplete(100);
  };

  return (
    <div className="reflection-activity">
      <div className="reflection-content">
        <div className="reflection-prompt">
          <h3>Reflection Exercise</h3>
          <p>{activity.content.prompt}</p>
        </div>
        
        {activity.content.guidelines && (
          <div className="reflection-guidelines">
            <h4>Guidelines:</h4>
            <ul>
              {activity.content.guidelines.map((guideline: string, index: number) => (
                <li key={index}>{guideline}</li>
              ))}
            </ul>
          </div>
        )}
        
        <div className="reflection-input-section">
          <label htmlFor="reflection-input">Your Reflection:</label>
          <textarea
            id="reflection-input"
            className="reflection-input"
            placeholder="Take your time to reflect on the questions above and write your thoughts here..."
            value={reflection}
            onChange={(e) => setReflection(e.target.value)}
            disabled={submitted}
            rows={8}
          />
        </div>
      </div>
      
      <div className="reflection-actions">
        <button 
          className="submit-btn"
          onClick={handleSubmit}
          disabled={submitted || !reflection.trim()}
        >
          {submitted ? '✓ Reflection Submitted' : 'Submit Reflection'}
        </button>
      </div>
    </div>
  );
};

export default ReflectionActivity;

